import { useState } from "react";
import { IMG_FALLBACK, resolveImg } from "@/lib/api";

export const ProductImage = ({ src, alt, className = "" }) => {
    const [err, setErr] = useState(false);
    return (
        <img
            src={err || !src ? IMG_FALLBACK : resolveImg(src)}
            alt={alt}
            loading="lazy"
            onError={() => setErr(true)}
            className={className}
        />
    );
};
